/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, type FC, useEffect } from 'react'
import { viewAssetService } from '../../services/viewAssetService'
import { MemoWraperHierarchy } from '../../../common/WraperHierarchy'

interface ViwAsset {
  loading: boolean
  ViewAsset: any
  errorMsg: boolean
}

const ViewAsset: FC<any> = (props) => {
  const [assetView, setassetView] = useState<ViwAsset>({
    loading: false,
    ViewAsset: {},
    errorMsg: false
  })

  useEffect(() => {
    viewAssetData()
  }, [props.assetId])

  const viewAssetData = (): any => {
    viewAssetService.viewAsset(props.assetId)
      .then((res: any) => {
        setassetView({ ...assetView, ViewAsset: res.data.data })
      })
      .catch(
        (res: any) => {
        }
      )
  }

  const { ViewAsset } = assetView

  return (
    <MemoWraperHierarchy
      site={ViewAsset?.hierarchyStructure?.site}
      id={props.assetId}
      handleClose={() => { props.viewAssetPopup(false) }}
      viewPopup={() => { props.viewAssetPopup('') }} />

  )
}

export default ViewAsset
